import http from './http/httpArea';

// 获取用户信息
export const authUserInfoApi = (params, config = {}) => http.get('/fuel-user/serveruser/app/auth/user/user_info', { params, ...config });

export const feedbackGetApi = (params, config = {}) => http.get(`/fuel-user/serveruser/app/user/feedback/${params.id}`, { params, ...config });
export const orderConfirmationApi = (params, config = {}) => http.get('/fuel-vehicle/servervehicle/app/sim/orderConfirmation', { params, ...config });

export const mapOrderConfirmationApi = (params, config = {}) => http.get('/fuel-vehicle/servervehicle/app/map/order/confirmation', { params, ...config });
export const mapEncryptDes = (params, config = {}) => http.get('/fuel-vehicle/servervehicle/app/map/order/encryptDes', { params, ...config });
